import { useHover } from '@sparemin/blockhead';
import React from 'react';
import ClipSelectPlayerContents, {
  ClipSelectPlayerContentsProps,
  ClipSelectPlayerInstance,
} from './ClipSelectPlayerContents';
import { ClipSelectVideoPlayerAnimationProvider } from './ClipSelectVideoPlayerAnimationContext';

export type ClipSelectPlayerProps<
  TRef extends ClipSelectPlayerInstance = ClipSelectPlayerInstance
> = Omit<ClipSelectPlayerContentsProps<TRef>, 'hoverProps' | 'videoRef'>;

const ClipSelectPlayer = React.forwardRef<
  ClipSelectPlayerInstance,
  ClipSelectPlayerProps
>(({ children, isPlaying, ...props }, ref) => {
  const { hoverProps, isHovered } = useHover({});

  return (
    <ClipSelectVideoPlayerAnimationProvider
      isHovered={isHovered}
      isPlaying={isPlaying}
    >
      <ClipSelectPlayerContents
        videoRef={ref}
        {...{ hoverProps, isPlaying }}
        {...props}
      >
        {children}
      </ClipSelectPlayerContents>
    </ClipSelectVideoPlayerAnimationProvider>
  );
}) as <TRef extends ClipSelectPlayerInstance = ClipSelectPlayerInstance>(
  props: ClipSelectPlayerProps<TRef> & { ref?: React.Ref<TRef> },
) => React.ReactElement | null;

export default ClipSelectPlayer;
